import React from "react";
import axios from "axios";

class Server extends React.Component {
  constructor(props) {
    super(props);
    this.type = 13;
    this.system = 1;
    let serverUrl = [
      "http://localhost:3000/" /* 0 */,
      "https://demoapi.sarvapps.ir/" /* 1 */,
      "https://api.emdcctv.com/" /* 2 */,
      "https://marketapi.ansar724.com/" /* 3 */,
      "https://foodapi.ansar724.com/" /* 4 */,
      "https://crmapi.sarvapps.ir/" /* 5 */,
      "https://api.aniabook.ir/" /* 6 */,
      "https://crm.sarvapps.ir/" /* 7 */,
      "https://api.samin360.ir/" /* 8 */,
      "https://api.ostoorehcart.com/" /* 9 */,
      "https://ansar724.iran.liara.run/" /* 10 */,
      "https://ansarcrm.iran.liara.run/" /* 11 */,
      "https://nikan.iran.liara.run/" /* 12 */,
      "https://ansar.iran.liara.run/" /* 13 */,
      "https://mehr724.iran.liara.run/" /* 14 */,
    ];
    let addressUrl = [
      "http://localhost:3000/",
      "https://demo.sarvapps.ir/",
      "https://emdcctv.com/",
      "https://aniashop.ir/",
      "",
      "",
      "https://aniabook.ir/",
      "https://crm.sarvapps.ir/",
      "https://samin360.ir/",
      "https://api.ostoorehcart.com/",
      "https://ansar724.iran.liara.run/",
      "https://ansarcrm.iran.liara.run/",
      "https://nikan.iran.liara.run/",
      "https://ansar.iran.liara.run/",
    ];

    this.systemCode = [
      "620641793b2d00005a007184" /* 0 */,
      "655cf16724610000bd003622"
    ]
    

    this.state = {
      isLoading: false,
      serverUrl: serverUrl[this.type],
      addressUrl: addressUrl[this.type],
    };
  }
  getSystem() {
    return this.systemCode[this.system];
  }
  getAddress() {
    return this.state.addressUrl;
  }
  getUrl(admin) {
    return admin
      ? this.state.serverUrl + "AdminApi/"
      : this.state.serverUrl + "MainApi/";
  }
  getAbsoluteUrl(admin) {
    return this.state.serverUrl;
  }
  getInfo() {
    if (this.state.serverUrl.indexOf("emdcctv") > -1)
      return {
        pay: "0",
        BestOff: "0",
        SmsType: "0",
        ShowPriceBeforeLogin: "0",
      };
    else
      return {
        pay: "1",
        BestOff: "1",
        SmsType: "1",
        ShowPriceBeforeLogin: "1",
      };
  }
  send(url, params, SuccessCallBack, ErrorCallBack) {
    this.setState({
      isLoading: true,
    });
    axios
      .post(this.state.serverUrl + url + "", params)
      .then((response) => {
        this.setState({
          isLoading: false,
        });
        SuccessCallBack(response, this.setState.isLoading);
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        ErrorCallBack(error, this.setState.isLoading);
      });
  }
  sendRaymand(
    url,
    params,
    SuccessCallBack,
    ErrorCallBack,
    temp,
    method,
    api,
    Transfer
  ) {
    var m = method || "POST";
    var XMLParser = require("react-xml-parser");
    var req;
    if (m === "POST") {
      if (!api) {
        req = {
          method: m,
          headers: {
            Accept: "application/json; charset=utf-8",
            "Content-Type": "application/json",
          },
          body: params,
        };
      } else {
        req = {
          method: "POST",
          headers: {
            "Access-Control-Allow-Headers": "*",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Im5hbWUiLCJyb2xlIjoidGVsIiwibmJmIjoxNTg0NjI3MzMxLCJleHAiOjE1ODQ2MzA5MzEsImlhdCI6MTU4NDYyNzMzMX0.VL6DIeI4l1QsXzlMmn7-EmNwakjdBKa-NanP7zHlpeY",
          },
          body: params,
        };
      }
    } else {
      if (api) {
        req = {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Im5hbWUiLCJyb2xlIjoidGVsIiwibmJmIjoxNTg0NjI3MzMxLCJleHAiOjE1ODQ2MzA5MzEsImlhdCI6MTU4NDYyNzMzMX0.VL6DIeI4l1QsXzlMmn7-EmNwakjdBKa-NanP7zHlpeY",
          },
        };
      }
    }
    if (!this.state.Port) {
      if (Transfer) {
        axios
          .post(url, params, {
            headers: {
              "Access-Control-Allow-Headers": "*",
              "Content-Type": "application/json",
              Authorization:
                "Bearer " +
                "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Im5hbWUiLCJyb2xlIjoidGVsIiwibmJmIjoxNTg0NjI3MzMxLCJleHAiOjE1ODQ2MzA5MzEsImlhdCI6MTU4NDYyNzMzMX0.VL6DIeI4l1QsXzlMmn7-EmNwakjdBKa-NanP7zHlpeY",
            },
          })
          .then(function (response) {
            SuccessCallBack(response.data);
          })
          .catch(function (error) {
            ErrorCallBack(error);
          });
      } else {
        fetch(url, req)
          .then((response) => response.json())
          .then((response) => {
            if (!api) {
              if (!temp) {
                try {
                  var xml = new XMLParser().parseFromString(response.d);
                } catch (e) {}
                SuccessCallBack(xml.children);
              } else {
                SuccessCallBack(response);
              }
            } else {
              SuccessCallBack(response);
            }
          })
          .catch((error) => {
            ErrorCallBack(error);
          });
      }
    } else {
      let serverUrl = this.state.serverUrl;
      req.port = this.state.Port;
      req.ip = this.state.Ip;
      axios
        .post(serverUrl + "MainApi/raymand_api" + "", req)
        .then((response) => {
          if (Transfer) {
            SuccessCallBack(response.data.result);
          } else {
            var xml = new XMLParser().parseFromString(response.data.result.d);
            SuccessCallBack(xml.children);
          }
        })
        .catch((error) => {
          ErrorCallBack(error);
        });
    }
  }
}
export default Server;
